import React, { useEffect, useRef, useState } from "react"
import axios from "axios"
import {
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  FormGroup,
  Input,
  Button,
  Badge,
  Label,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ButtonDropdown,
  Card,
  CardBody,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
} from "reactstrap"
import Select from "react-select"
import "./TicketClient/TicketClientstyle.css"
import { useSelector } from "react-redux"
import configs from "config"
import TicketClientLog from "./TicketClient/TicketClientLog"
import SingleComment from "./TicketList/TicketComments/SingleComment"
import CustomSpinner from "components/Common/CustomSpinner"
const { Url, apiVersion } = configs.client
import NoMessageFound from "../../components/Common/Icons/Chat/Conversation/no-message-found.png"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"

import usFlag from "../../assets/images/flags/us.jpg"
import arabicFlag from "../../assets/images/flags/saudi-arabia.png"

import LOGO from "../../assets/images/logo.png"
import Footer from "components/VerticalLayout/Footer"
import { AnimatePresence, motion } from "framer-motion"

const projectNoLabelKeys = {
  reference: "projectNo.reference",
  policy: "projectNo.policy",
  request: "projectNo.request",
  survey: "projectNo.survey",
}

function TicketClient() {
  const { access, authorized, userData } = useSelector(state => ({
    access: state.Login?.userAccess,
    authorized: state.Login.authorized,
    userData: state.Login.userData,
  }))

  const { t, i18n } = useTranslation()
  const [loadingAfterComment, setLoadingAfterComment] = useState(false)
  const [open, setOpen] = useState(["1", "2", "3"])
  const [ticketData, setTicketData] = useState(null)
  const [ticketLogData, setTicketLogData] = useState([])
  const [loadingData, setLoadingData] = useState(true)
  const [editedQuestions, setEditedQuestions] = useState(null)
  const [noCommentsFound, setNoCommentsFound] = useState(false)
  const [comments, setComments] = useState([])
  const [selectedFiles, setSelectedFiles] = useState([])
  const [commentText, setCommentText] = useState("")
  const [drp_link, setdrp_link] = useState(false)
  const [clientFeedbackRating, setClientFeedbackRating] = useState("")
  const [feedbackText, setFeedbackText] = useState("")
  const [sendingFeedback, setSendingFeedback] = useState(false)
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false)
  const [noTicketFound, setNoTicketFound] = useState(false)
  const [noTicketMsg, setNoTicketMsg] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [feedbackCardPlace, setFeedbackCardPlace] = useState(
    t("feedbackCardPlace")
  )

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState)

  const commentsEndRef = useRef(null)
  const params = useParams()
  const hasProjectNoObject =
    ticketData?.projectNo && typeof ticketData.projectNo === "object"
  const projectNoType = hasProjectNoObject
    ? ticketData.projectNo.type?.toLowerCase()
    : null
  const projectNoLabelKey = projectNoLabelKeys[projectNoType]
  const projectNoValue = hasProjectNoObject
    ? ticketData.projectNo.value || ticketData?.refNo
    : ticketData?.refNo

  // Change language function
  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
    document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr")
  }

  const toggle = id => {
    if (open.includes(id)) {
      setOpen(open.filter(item => item !== id))
    } else {
      setOpen([...open, id])
    }
  }

  const hasEditableFields = () => {
    return ticketData?.questions?.some(
      question => question.field?.endUserPermission === "edit"
    )
  }

  const fetchDataAfterCommentting = () => {
    setLoadingAfterComment(true)

    axios
      .get(`${Url}/${apiVersion}/client`, {
        headers: {
          Authorization: `Bearer ${params.clientToken}`,
        },
      })
      .then(res => {
        setTicketData(res.data.data.ticket)
        setTicketLogData(res.data.data.ticketLogs)
        setComments(res.data.data.ticketComments)

        res.data.data.ticket.feedback &&
          setFeedbackText(res.data.data.ticket.feedback)

        res.data.data.ticket.rating &&
          setClientFeedbackRating(res.data.data.ticket.rating)

        res.data.data.ticketComments.length === 0
          ? setNoCommentsFound(true)
          : setNoCommentsFound(false)

        setLoadingAfterComment(false)
        setEditedQuestions(
          res.data.data.ticket?.questions?.map(question => ({
            fieldId: question.field?._id,
            answer: question.answer.join(", "),
          }))
        )
      })
      .catch(err => {
        setLoadingAfterComment(false)

        if (err.response?.status === 404) {
          setNoTicketFound(true)
          setNoTicketMsg(err.response.data.message)
        }

        if (err.response?.status === 401 || err.response?.status === 0) {
          dispatch(unAuthUser())
        } else {
          console.log(err)
        }
      })
  }

  const fetchTicketData = () => {
    setLoadingData(true)

    axios
      .get(`${Url}/${apiVersion}/client`, {
        headers: {
          Authorization: `Bearer ${params.clientToken}`,
        },
      })
      .then(res => {
        setTicketData(res.data.data.ticket)
        setTicketLogData(res.data.data.ticketLogs)
        setComments(res.data.data.ticketComments)

        res.data.data.ticket.feedback &&
          setFeedbackText(res.data.data.ticket.feedback)

        res.data.data.ticket.rating &&
          setClientFeedbackRating(res.data.data.ticket.rating)

        res.data.data.ticketComments.length === 0
          ? setNoCommentsFound(true)
          : setNoCommentsFound(false)

        setLoadingData(false)
        setEditedQuestions(
          res.data.data.ticket?.questions?.map(question => ({
            fieldId: question.field?._id,
            answer: question.answer.join(", "),
          }))
        )
        // console.log("res token", res)
      })
      .catch(err => {
        setLoadingData(false)

        if (err.response?.status === 404) {
          setNoTicketFound(true)
          setNoTicketMsg(err.response.data.message)
        }

        if (err.response?.status === 401 || err.response?.status === 0) {
          dispatch(unAuthUser())
        } else {
          console.log(err)
        }
      })
  }

  const submitFeedback = () => {
    setSendingFeedback(true)

    let data = {}

    if (clientFeedbackRating) {
      data.rating = clientFeedbackRating
    }

    if (feedbackText) {
      data.feedback = feedbackText
    }

    axios
      .patch(`${Url}/${apiVersion}/client/feedback`, data, {
        headers: {
          Authorization: `Bearer ${params.clientToken}`,
        },
      })
      .then(res => {
        setSendingFeedback(false)
        setFeedbackSubmitted(true)

        console.log("Feedback submitted successfully", res.data)
      })
      .catch(err => {
        setSendingFeedback(false)
      })
  }

  const handleFileSelect = event => {
    const files = Array.from(event.target.files)
    setSelectedFiles(prevFiles => [...prevFiles, ...files])
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: state.isSelected ? "#333" : "#000",
    }),
    control: provided => ({
      ...provided,
      borderColor: "#ddd",
    }),
    menu: provided => ({
      ...provided,
      backgroundColor: "#fff",
    }),
    menuList: provided => ({
      ...provided,
      backgroundColor: "#fff",
    }),
  }

  const renderEditableFields = () => {
    return ticketData?.questions
      ?.filter(question => question.field?.endUserPermission === "edit")
      .map((question, index) => renderField(question.field, index, true))
  }

  const renderField = (field, index, editable = false) => {
    if (field?.endUserPermission === "hidden") {
      return null
    }

    const isEmptyRequiredField =
      field?.required &&
      (!editedQuestions[index].answer ||
        editedQuestions[index].answer.trim() === "")

    return (
      <FormGroup key={field?._id}>
        <Label for={field?._id}>
          {field?.endUserView}{" "}
          {field?.required && <span className="text-danger">*</span>}
        </Label>
        {(() => {
          switch (field?.type.value) {
            case "dropdown":
              return (
                <Select
                  id={field?._id}
                  value={
                    editedQuestions[index].answer
                      ? {
                          value: editedQuestions[index].answer,
                          label: editedQuestions[index].answer,
                        }
                      : null
                  }
                  onChange={selectedOption =>
                    handleInputChange(
                      index,
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  options={field?.values.map(value => ({
                    value,
                    label: value,
                  }))}
                  isDisabled={!editable}
                  isClearable
                  placeholder={`Select ${field?.endUserView}`}
                  className="basic-select"
                  classNamePrefix="select"
                  styles={customStyles}
                />
              )
            case "text":
              return (
                <Input
                  type="text"
                  id={field?._id}
                  value={editedQuestions[index].answer}
                  placeholder={field?.endUserView}
                  onChange={e => handleInputChange(index, e.target.value)}
                  readOnly={!editable}
                />
              )
            case "number":
              return (
                <Input
                  type="text"
                  id={field?._id}
                  value={editedQuestions[index].answer}
                  placeholder={field?.endUserView}
                  pattern="[0-9]*"
                  onInput={e => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "")
                  }}
                  onChange={e => handleInputChange(index, e.target.value)}
                  readOnly={!editable}
                />
              )
            case "text-area":
              return (
                <Input
                  type="textarea"
                  id={field?._id}
                  value={editedQuestions[index].answer}
                  placeholder={field?.endUserView}
                  onChange={e => handleInputChange(index, e.target.value)}
                  readOnly={!editable}
                />
              )
            case "checkbox":
              return (
                <FormGroup
                  check
                  className="mb-2"
                  style={{ textAlign: t("checkboxAlign") }}
                >
                  <Label check>
                    <Input
                      type="checkbox"
                      className="d-block"
                      id={field?._id}
                      checked={editedQuestions[index].answer}
                      onClick={e => handleInputChange(index, e.target.checked)}
                      disabled={!editable}
                    />{" "}
                    {field?.endUserView}{" "}
                    {field?.required && <span className="text-danger">*</span>}
                  </Label>
                </FormGroup>
              )
            case "multi-select":
              return (
                <Select
                  isMulti
                  name={field?._id}
                  options={field?.values.map(value => ({
                    value,
                    label: value,
                  }))}
                  value={editedQuestions[index].answer
                    .split(", ")
                    .map(value => ({
                      value,
                      label: value,
                    }))} // Use the current state for the value
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={selectedOptions => {
                    const values = selectedOptions.map(option => option.value)
                    handleInputChange(index, values.join(", "))
                  }}
                  styles={customStyles}
                  isDisabled={!editable}
                />
              )
            case "decimal":
              return (
                <Input
                  type="text"
                  id={field?._id}
                  value={editedQuestions[index].answer}
                  placeholder={field?.endUserView}
                  onChange={e => handleInputChange(index, e.target.value)}
                  onInput={e => {
                    const value = e.target.value
                    e.target.value = value.match(/^\d*\.?\d{0,4}$/)
                      ? value
                      : value.slice(0, -1)
                  }}
                  readOnly={!editable}
                />
              )
            case "date":
              return (
                <Input
                  type="date"
                  id={field?._id}
                  value={editedQuestions[index].answer}
                  onChange={e => handleInputChange(index, e.target.value)}
                  readOnly={!editable}
                />
              )
            default:
              return null
          }
        })()}

        {isEmptyRequiredField && (
          <div className="text-danger mt-1">Required.</div>
        )}
      </FormGroup>
    )
  }

  useEffect(() => {
    if (!loadingAfterComment && comments.length > 0) {
      scrollToBottom()
    }
  }, [comments, loadingAfterComment])

  const scrollToBottom = () => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  const handleSendComment = statusId => {
    setLoadingAfterComment(true)

    let formData = new FormData()

    if (commentText) {
      formData.append("text", commentText)
    }

    selectedFiles.forEach(file => {
      formData.append("files", file)
    })

    axios
      .post(`${Url}/${apiVersion}/client/comment`, formData, {
        headers: {
          Authorization: `Bearer ${params.clientToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(res => {
        setCommentText("")
        setSelectedFiles([])

        fetchDataAfterCommentting()
      })
      .catch(err => {
        console.log(err)
      })
  }

  const isImage = filename => {
    return /\.(jpg|jpeg|png|gif)$/.test(filename)
  }

  const renderSelectedFiles = () => {
    return (
      <div
        className="d-flex align-items-center p-2 shadow"
        style={{
          backgroundColor: "#F2F2F7",
          borderRadius: "10px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          maxWidth: "70%",
          position: "absolute",
          left: "0",
          bottom: "100%",
          border: "1px solid rgba(0,0,0,0.20)",
        }}
      >
        {selectedFiles.map((file, index) => (
          <div
            key={index}
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              width: "100px",
              height: "100px",
              margin: "5px",
              padding: "5px",
              backgroundColor: "#FFF",
              borderRadius: "5px",
              boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
              position: "relative",
            }}
          >
            <button
              type="button"
              onClick={() => handleRemoveFile(index)}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <i className="mdi mdi-close-circle text-danger"></i>
            </button>
            {isImage(file.name) ? (
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "2px",
                  objectFit: "cover",
                }}
              />
            ) : (
              <i
                className={`mdi mdi-file-document-outline mdi-36px text-secondary`}
              ></i>
            )}
            <small style={{ fontSize: "10px", textAlign: "center" }}>
              {file.name.length > 10
                ? `${file.name.substring(0, 7)}...`
                : file.name}
            </small>
            <small style={{ fontSize: "10px", textAlign: "center" }}>
              Size: {(file.size / 1024).toFixed(2)} KB
            </small>
          </div>
        ))}
      </div>
    )
  }

  const toggleFormQuestionsEditModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleInputChange = (index, value) => {
    const updatedQuestions = [...editedQuestions]
    updatedQuestions[index].answer = typeof value === "boolean" ? value : value
    setEditedQuestions(updatedQuestions)
  }

  const handleSaveChanges = () => {
    toggleFormQuestionsEditModal()
    setLoadingData(true)

    // Prepare request payload
    const requestBody = {
      questions: editedQuestions.map(q => ({
        field: q.fieldId,
        answer:
          typeof q.answer === "boolean"
            ? [`${q.answer}`]
            : q.answer.split(", ").map(answer => answer.trim()),
      })),
    }

    // Send request to update form questions
    axios
      .patch(`${Url}/${apiVersion}/client/form`, requestBody, {
        headers: {
          Authorization: `Bearer ${params.clientToken}`,
          "Content-Type": "application/json",
        },
      })
      .then(res => {
        console.log("Form updated successfully", res.data)

        setLoadingData(false)
        fetchTicketData()
      })
      .catch(err => {
        console.log(err)
        setLoadingData(false)
      })
  }

  useEffect(() => {
    fetchTicketData()
  }, [])

  useEffect(() => {
    if (feedbackSubmitted) {
      const timer = setTimeout(() => {
        setFeedbackSubmitted(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [feedbackSubmitted])

  useEffect(() => {
    // Define a function to check the screen width
    const handleResize = () => {
      if (window.innerWidth >= 767) {
        setFeedbackCardPlace("5%")
      } else {
        setFeedbackCardPlace("10%")
      }
    }

    // Call the function initially to set the correct value
    handleResize()

    // Add event listener to handle window resize
    window.addEventListener("resize", handleResize)

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize)
  }, [t])

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={i18n.language}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{
          duration: 0.1,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        <div className="ticket-client-page">
          <div className="py-5 shadow ticket-page-header-container position-relative">
            <div className="px-3 pb-4">
              <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <img width="180px" height="50px" src={LOGO} />

                  {/* Language Switcher as Dropdown */}
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    className="language-switcher font-size-16"
                  >
                    <DropdownToggle
                      caret
                      className="btn btn-secondary bg-white text-secondary btn-sm font-size-16 d-flex align-items-center gap-2"
                    >
                      {i18n.language === "ar" ? (
                        <img
                          src={arabicFlag}
                          alt="saudi Flag"
                          width="20"
                          className=""
                        />
                      ) : (
                        <img
                          src={usFlag}
                          alt="USA Flag"
                          width="20"
                          className=""
                        />
                      )}{" "}
                      {i18n.language === "ar" ? (
                        <span>AR</span>
                      ) : (
                        <span>EN</span>
                      )}
                      {/* Display active language */}
                    </DropdownToggle>
                    <DropdownMenu
                      className="font-size-16"
                      style={{ minWidth: "auto" }}
                    >
                      <DropdownItem
                        style={{ width: "auto" }}
                        className="px-2 py-0 d-flex align-items-center gap-2"
                        onClick={() => changeLanguage("en")}
                      >
                        <img
                          src={usFlag}
                          alt="USA Flag"
                          width="20"
                          className=""
                        />
                        <span>EN</span>
                      </DropdownItem>
                      <DropdownItem
                        style={{ width: "auto" }}
                        className="px-2 py-0 d-flex align-items-center gap-2"
                        onClick={() => changeLanguage("ar")}
                      >
                        <img
                          src={arabicFlag}
                          alt="saudi Flag"
                          width="20"
                          className=""
                        />
                        <span>AR</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <h3 className="mb-0 ticket-client-heading font-size-36">
                  {t("welcomeBack")}
                </h3>
                <p className="ticket-client-page-heading-paragraph font-size-18">
                  {t("youCanTrack")}
                </p>
              </div>
            </div>

            {loadingData || noTicketFound ? (
              ""
            ) : (
              <div
                className={`bg-white p-3 rounded mb-3 shadow rounded-3 position-absolute ticket-client-page-feedback ${
                  submitFeedback && "text-center py-4"
                }`}
                style={{ [t("feedbackCardPlace")]: feedbackCardPlace }}
              >
                {sendingFeedback ? (
                  <CustomSpinner />
                ) : feedbackSubmitted ? (
                  <div className="py-5 mt-2">
                    <i className="fas fa-check-circle fa-10x text-center text-success"></i>

                    <h4 className="mt-2">
                      {t("feedbackSubmittedMessage")}
                      <br /> {t("feedbackSubmittedThankMessage")}
                    </h4>
                  </div>
                ) : (
                  <>
                    <h5
                      className="font-size-18 mb-3"
                      style={{ color: "#6B7889" }}
                    >
                      {t("feedbackPrompt")}
                    </h5>

                    <FormGroup
                      className="d-flex justify-content-around"
                      style={{ marginBottom: "0" }}
                    >
                      {/* Thumbs Up */}
                      <div
                        onClick={() => setClientFeedbackRating("Positive")}
                        className={`text-center single-feedback ${
                          clientFeedbackRating === "Positive" && "active"
                        }`}
                      >
                        <span
                          role="img"
                          aria-label="Positive"
                          style={{ fontSize: "2rem" }}
                        >
                          🙂
                        </span>
                      </div>

                      {/* Thumbs Down */}
                      <div
                        onClick={() => setClientFeedbackRating("Negative")}
                        className={`text-center single-feedback ${
                          clientFeedbackRating === "Negative" && "active"
                        }`}
                      >
                        <span
                          role="img"
                          aria-label="Negative"
                          style={{ fontSize: "2rem" }}
                        >
                          🙁
                        </span>
                      </div>

                      {/* Okay */}
                      <div
                        onClick={() => setClientFeedbackRating("Neutral")}
                        className={`text-center single-feedback ${
                          clientFeedbackRating === "Neutral" && "active"
                        }`}
                      >
                        <span
                          role="img"
                          aria-label="Neutral"
                          style={{ fontSize: "2rem" }}
                        >
                          😐
                        </span>
                      </div>
                    </FormGroup>

                    <p className="text-muted font-size-14">
                      {t("chooseExperience")}
                    </p>

                    {/* Suggestion Input */}
                    <FormGroup>
                      <Input
                        type="textarea"
                        name="suggestions"
                        id="suggestions"
                        rows="4"
                        className="rounded-3"
                        value={feedbackText}
                        placeholder={t("suggestImprovement")}
                        onChange={e => {
                          setFeedbackText(e.target.value)
                        }}
                      />
                    </FormGroup>

                    {/* Submit Button */}
                    <Button
                      disabled={!clientFeedbackRating}
                      onClick={() => submitFeedback()}
                      color="secondary"
                      className="py-3 font-size-16 rounded-4"
                      block
                    >
                      {t("sendFeedback")}
                    </Button>
                  </>
                )}
              </div>
            )}
          </div>

          {loadingData ? (
            <div style={{ minHeight: "60vh" }}>
              <CustomSpinner />
            </div>
          ) : noTicketFound ? (
            <Row className="p-5">
              <Alert color="danger">{t("noTickedFoundMSG")}</Alert>
            </Row>
          ) : (
            <Row className="g-3 p-5">
              {/* First Column with Ticket Details Accordion */}
              <Col sm="12" md="4">
                <Accordion open={open} toggle={toggle} className="bg-light">
                  <AccordionItem
                    style={{ backgroundColor: "#F8F8FB", border: "none" }}
                  >
                    <AccordionHeader
                      targetId="1"
                      className="client-ticket-custom-accordion-header shadow-lg mb-2"
                      style={{
                        backgroundColor: "#fff",
                        padding: ".5rem",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {t("ticketDetails")}
                    </AccordionHeader>
                    <AccordionBody
                      accordionId="1"
                      className="client-ticket-custom-accordion-body"
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "1rem",
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                        maxHeight: "600px",
                        minHeight: "600px",
                        overflow: "auto",
                      }}
                    >
                      {loadingData ? (
                        <CustomSpinner />
                      ) : (
                        <>
                          <div className="mb-3 d-flex justify-content-between">
                            <h5 className="mb-0 fw-bold">{t("ticketInfo")}</h5>

                            {hasEditableFields() &&
                            ticketData?.status?.category !== "solved" ? (
                              <i
                                className="bx bx-edit-alt bx-sm"
                                style={{ cursor: "pointer" }}
                                onClick={toggleFormQuestionsEditModal}
                              ></i>
                            ) : (
                              <div></div>
                            )}
                          </div>

                          <div className="">
                            <h6 className="text-muted">
                              {t("status")}{" "}
                              <span className="text-danger">*</span>
                            </h6>

                            <p className="border border-secondary border-opacity-25 rounded-1 p-1">
                              {ticketData?.status?.category?.toLowerCase() ==
                                "pending" && (
                                <Badge
                                  pill
                                  className="badge-soft-warning ms-1 font-size-12"
                                >
                                  <span className="font-size-16 me-1">
                                    &#9679;
                                  </span>{" "}
                                  {ticketData.status.endUserDisplayName}
                                </Badge>
                              )}

                              {ticketData?.status?.category?.toLowerCase() ==
                                "solved" && (
                                <Badge
                                  pill
                                  className="badge-soft-secondary ms-1 font-size-12"
                                >
                                  <span className="font-size-16 me-1">
                                    &#9679;
                                  </span>{" "}
                                  {ticketData.status.endUserDisplayName}
                                </Badge>
                              )}

                              {ticketData?.status?.category?.toLowerCase() ==
                                "new" && (
                                <Badge
                                  pill
                                  className="badge-soft-danger ms-1 font-size-12"
                                >
                                  <span className="font-size-16 me-1">
                                    &#9679;
                                  </span>{" "}
                                  {ticketData.status.endUserDisplayName}
                                </Badge>
                              )}

                              {ticketData?.status?.category?.toLowerCase() ==
                                "open" && (
                                <Badge
                                  pill
                                  className="badge-soft-success ms-1 font-size-12"
                                >
                                  <span className="font-size-16 me-1">
                                    &#9679;
                                  </span>{" "}
                                  {ticketData.status.endUserDisplayName}
                                </Badge>
                              )}

                              {(!ticketData?.status?.category ||
                                (ticketData?.status?.category?.toLowerCase() !==
                                  "new" &&
                                  ticketData?.status?.category?.toLowerCase() !==
                                    "open" &&
                                  ticketData?.status?.category?.toLowerCase() !==
                                    "solved" &&
                                  ticketData?.status?.category?.toLowerCase() !==
                                    "pending")) && (
                                <Badge
                                  pill
                                  className="badge-soft-dark ms-1 font-size-12"
                                >
                                  <span className="font-size-16 me-1">
                                    &#9679;
                                  </span>{" "}
                                  {ticketData?.status?.category || "Unknown"}
                                </Badge>
                              )}
                            </p>
                          </div>

                          <div className="">
                            <h6 className="text-muted">
                              {projectNoLabelKey
                                ? t(projectNoLabelKey)
                                : t("refNo")}{" "}
                              <span className="text-danger">*</span>
                            </h6>

                            <p className="border border-secondary border-opacity-25 rounded-1 p-1">
                              {projectNoValue
                                ? projectNoValue
                                : t("enterProjectNo")}
                            </p>
                          </div>

                          <div className="">
                            <h6 className="text-muted">
                              {t("category")}{" "}
                              <span className="text-danger">*</span>
                            </h6>

                            <p className="border border-secondary border-opacity-25 rounded-1 p-1">
                              {ticketData?.category?.name
                                ? ticketData?.category?.name
                                : "Choose a category name"}
                            </p>
                          </div>

                          <div className="my-3 d-flex justify-content-start">
                            <h5 className="mb-0 fw-bold mt-1">{t("form")}</h5>
                          </div>

                          {ticketData?.questions?.map((question, index) =>
                            renderField(question.field, index, false)
                          )}
                        </>
                      )}
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              {/* Second Column with Ticket Logs Accordion */}
              <Col sm="12" md="4">
                <Accordion open={open} toggle={toggle} className="bg-light">
                  <AccordionItem
                    style={{ backgroundColor: "#F8F8FB", border: "none" }}
                  >
                    <AccordionHeader
                      targetId="2"
                      className="client-ticket-custom-accordion-header shadow-lg mb-2"
                      style={{
                        backgroundColor: "#fff",
                        padding: ".5rem",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {t("ticketLogs")}
                    </AccordionHeader>
                    <AccordionBody
                      accordionId="2"
                      className="client-ticket-custom-accordion-body"
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "1rem",
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                        maxHeight: "600px",
                        minHeight: "600px",
                        overflow: "auto",
                      }}
                    >
                      <TicketClientLog
                        ticketLogData={ticketLogData}
                        loading={loadingData}
                      />
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              {/* Third Column with Feedback Section and Ticket Comments Accordion */}
              <Col sm="12" md="4" className="ticket-client-page-third-col">
                {/* Ticket Comments Accordion */}
                <Accordion open={open} toggle={toggle} className="bg-light">
                  <AccordionItem
                    style={{ backgroundColor: "#F8F8FB", border: "none" }}
                  >
                    <AccordionHeader
                      targetId="3"
                      className="client-ticket-custom-accordion-header shadow-lg mb-2"
                      style={{
                        backgroundColor: "#fff",
                        padding: ".5rem",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {t("ticketComments")}
                    </AccordionHeader>
                    <AccordionBody
                      accordionId="3"
                      className="client-ticket-custom-accordion-body"
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "1rem 0",
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                        maxHeight: "auto",
                        minHeight: "470px",
                        overflow: "auto",
                      }}
                    >
                      <Card
                        className="px-1 shadow-none rounded-0"
                        style={{ marginBottom: "0" }}
                      >
                        <CardBody className="shadow-none p-1">
                          <div className="d-flex justify-content-between align-items-center pb-2">
                            <h5 className="border-bottom mb-0 text-muted">
                              {ticketData?.order
                                ? t("ticket_number_with_order", {
                                    order: ticketData.order,
                                  })
                                : "Ticket Number"}
                            </h5>

                            <span></span>
                          </div>

                          {/* Comments Section */}
                          <Card
                            className="my-3 shadow"
                            ref={commentsEndRef}
                            style={{ marginBottom: "0" }}
                          >
                            <CardBody
                              className="shadow"
                              style={{
                                padding: "1rem 1.25rem",
                                height: "calc(7px + 35vh)",
                                maxHeight: "calc(7px + 35vh)",
                                overflow: "auto",
                              }}
                            >
                              {noCommentsFound ? (
                                <div className="align-self-center d-flex flex-column justify-content-center mw-50 my-auto">
                                  <img
                                    className="mx-auto"
                                    style={{ height: "13.25rem" }}
                                    src={NoMessageFound}
                                  />
                                  <h6 className="mx-auto font-size-20">
                                    No Comments Yet!
                                  </h6>
                                </div>
                              ) : loadingAfterComment ? (
                                <CustomSpinner />
                              ) : (
                                comments?.map(
                                  comment =>
                                    comment.type !== "note" && (
                                      <SingleComment
                                        key={comment._id}
                                        comment={comment}
                                      />
                                    )
                                )
                              )}

                              <div ref={commentsEndRef} />
                            </CardBody>
                          </Card>

                          {/* Input and Buttons Section */}
                          <Card
                            className="shadow"
                            style={{ marginBottom: "0" }}
                          >
                            <CardBody
                              className="shadow position-relative"
                              style={{
                                padding: "1rem 1.25rem",
                              }}
                            >
                              {selectedFiles.length > 0 &&
                                renderSelectedFiles()}

                              {comments.length === 0 ? (
                                <CardBody
                                  className="shadow position-relative"
                                  style={{
                                    padding: "1rem 1.25rem",
                                    backgroundColor: "#FFFFFF",
                                    minHeight: "142px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <p className="my-auto text-center font-size-18">
                                    {t("notAllowedToComment")}
                                  </p>
                                </CardBody>
                              ) : ticketData?.status?.category === "solved" ? (
                                <CardBody
                                  className="shadow position-relative"
                                  style={{
                                    padding: "1rem 1.25rem",
                                    backgroundColor: "#FFFFFF",
                                    minHeight: "142px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <p className="my-auto text-center font-size-18">
                                    {t("solvedTicket")}
                                  </p>
                                </CardBody>
                              ) : (
                                <>
                                  <Input
                                    type="textarea"
                                    name="commentinput"
                                    placeholder={t("commentHere")}
                                    className="mb-2"
                                    style={{ border: "none" }}
                                    value={commentText}
                                    bsSize="lg"
                                    onChange={e =>
                                      setCommentText(e.target.value)
                                    }
                                  />

                                  <div className="d-flex justify-content-end align-items-center">
                                    <div>
                                      <Button
                                        outline
                                        color="secondary"
                                        className="mx-2"
                                        disabled={loadingAfterComment}
                                        onClick={() =>
                                          document
                                            .getElementById("fileInput")
                                            .click()
                                        }
                                      >
                                        <i className="mdi mdi-attachment me-1"></i>{" "}
                                        {t("attachment")}
                                      </Button>
                                      <input
                                        type="file"
                                        id="fileInput"
                                        style={{ display: "none" }}
                                        multiple
                                        onChange={handleFileSelect}
                                      />

                                      <ButtonDropdown
                                        isOpen={drp_link}
                                        toggle={() => setdrp_link(!drp_link)}
                                      >
                                        <Button
                                          id="caret"
                                          color="secondary"
                                          onClick={() =>
                                            handleSendComment(null)
                                          }
                                          disabled={
                                            (!commentText &&
                                              selectedFiles.length === 0) ||
                                            loadingAfterComment
                                          }
                                        >
                                          {t("submit_comment")}
                                        </Button>
                                      </ButtonDropdown>
                                    </div>
                                  </div>
                                </>
                              )}
                            </CardBody>
                          </Card>
                        </CardBody>
                      </Card>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>
            </Row>
          )}

          <Modal
            isOpen={isModalOpen}
            toggle={toggleFormQuestionsEditModal}
            centered
          >
            <ModalHeader
              className="modal-edit-header"
              toggle={toggleFormQuestionsEditModal}
            >
              {t("clientEditFormQuestions")}
            </ModalHeader>
            <ModalBody>{renderEditableFields()}</ModalBody>
            <ModalFooter
              className={i18n.language === "ar" && "justify-content-start"}
            >
              {i18n.language === "ar" ? (
                <>
                  <Button color="secondary" onClick={handleSaveChanges}>
                    {t("confirmEditing")}
                  </Button>
                  <Button
                    color="secondary"
                    outline
                    onClick={toggleFormQuestionsEditModal}
                  >
                    {t("cancelEditing")}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    color="secondary"
                    outline
                    onClick={toggleFormQuestionsEditModal}
                  >
                    {t("cancelEditing")}
                  </Button>
                  <Button color="secondary" onClick={handleSaveChanges}>
                    {t("confirmEditing")}
                  </Button>
                </>
              )}
            </ModalFooter>
          </Modal>

          <Footer />
        </div>
      </motion.div>
    </AnimatePresence>
  )
}

export default TicketClient
